module.exports = __webpack_public_path__ + "img/34.abbe6e02.png";